//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { disabledDate, dateFormat } from '@/plugin/format.js'
import PictureList from '@/components/PictureList.vue'

export default {
  data() {
    return {
      filters: {
        keyword: '',
        status: '',
        repairshop: ''
      },
      datas: [],
      canDeleteList: [],
      repairshops: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      pictureVisible: false,
      dispatchVisible: false,
      descriptionVisible: false,
      editLoading: false,
      dispatchForm: {
        repairshop: null
      },
      descriptionForm: {
        description: ''
      },
      dispatchFormRules: {
        repairshop: [
          { required: true, message: '请选择维修店', trigger: 'blur' }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return disabledDate(time)
        }
      },

      dataForm: {},
      selections: [], // 列表选中列
      approvalList: [],
      dispatchList: [],
      picturelist: [],
      opinion: ''
    }
  },
  methods: {
    querylist: function() {
      this.currentPage = 1
      this.getlist()
    },
    getRepairShop() {
      let params = {}
      this.$api
        .getRepairShop(params)
        .then(res => {
          if (res.Status === 1) {
            this.repairshops = res.Entity
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          alert(res)
        })
    },
    getlist: function() {
      let params = {
        Keyword: this.filters.keyword.trim()
      }
      if (this.filters.status) {
        params.Status = this.filters.status
      }
      if (this.filters.repairshop) {
        params.RepairShop = this.filters.repairshop
      }
      params.PageIndex = this.currentPage - 1
      params.PageSize = this.pageSize
      this.$api
        .getRepairBypage(params)
        .then(res => {
          if (res.Status === 1) {
            var list = []
            res.Entity.forEach(dev => {
              if (dev.Status === '已报修') dev.StatusId = 1
              if (dev.Status === '已派工') dev.StatusId = 2
              if (dev.Status === '已处理') dev.StatusId = 3
              list.push(dev)
            })
            list.sort((a, b) => a.StatusId - b.StatusId)

            this.datas = list
            this.total = res.TotalRowsCount
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          this.$alert('获取数据错误！', '错误', {
            confirmButtonText: '确定'
          })
        })
    },
    handleDispatch: function(device) {
      this.dispatchList = []
      this.dispatchList.push(device)

      this.dispatchVisible = true
    },
    handleDispatchList: function() {
      this.$refs.dispatchForm.validate(valid => {
        if (valid) {
          this.$confirm(
            '确认派工' + this.dispatchList.length.toString() + '台设备报修吗？',
            '提示',
            { cancelButtonClass: 'btn-custom-cancel' }
          ).then(() => {
            var params = []
            this.dispatchList.forEach(dev => {
              params.push({
                Id: dev.Id,
                RepairShop: this.dispatchForm.repairshop
              })
            })
            this.$api.dispatchRepair(params).then(res => {
              if (res.Status === 1) {
                this.$message({
                  message: '派工成功',
                  type: 'success'
                })

                this.getlist()
                this.dispatchVisible = false
              } else {
                this.$alert(res.Message.replace(/\n\r/g, '</br>'), '错误', {
                  confirmButtonText: '确定'
                })
              }
            })
          })
        }
      })
    },
    editDescription(row) {
      this.descriptionVisible = true
      let df = Object.assign({}, row)
      this.dataForm = df
      this.descriptionForm.description = df.Description
    },
    handleDescription: function() {
      var param = {
        Id: this.dataForm.Id,
        Description: this.descriptionForm.description
      }

      this.$api.descriptionRepair(param).then(res => {
        if (res.Status === 1) {
          this.$message({
            message: '保存成功',
            type: 'success'
          })

          this.getlist()
          this.descriptionVisible = false
        } else {
          this.$alert(res.Message.replace(/\n\r/g, '</br>'), '错误', {
            confirmButtonText: '确定'
          })
        }
      })
    },
    handleDelete: function(device) {
      this.canDeleteList = []
      this.canDeleteList.push(device)
      this.handleDeleteList()
    },
    handleDeleteList: function() {
      this.$confirm(
        '确认删除' + this.canDeleteList.length.toString() + '台设备报修吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        let ids = []
        this.canDeleteList.forEach(pt => {
          ids.push(pt.Id)
        })
        this.$api.deleteIdsRepair(ids).then(res => {
          if (res.Status === 1) {
            this.$message({ message: '删除成功', type: 'success' })
            this.getlist()
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
      })
    },
    handleApproval: function(device) {
      this.approvalList = []
      this.approvalList.push(device)
      this.handleApprovalList()
    },
    handleApprovalList: function() {
      this.$confirm(
        '确认完成' + this.approvalList.length.toString() + '台设备报修吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        let ids = []
        this.approvalList.forEach(pt => {
          ids.push(pt.Id)
        })
        this.$api.approvalRepair(ids).then(res => {
          if (res.Status === 1) {
            this.$message({ message: '确认成功', type: 'success' })
            this.getlist()
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
      })
    },
    handleShowPicture: function(params) {
      this.pictureVisible = true
      this.$api
        .adminGetFile(params)
        .then(res => {
          if (res.Status === 1) {
            var list = []
            res.Entity.forEach(item => {
              list.push('data:image/png;base64,' + item.Contents)
            })
            this.picturelist = list
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          this.$alert('获取数据错误！', '错误', {
            confirmButtonText: '确定'
          })
        })
    },
    selectionChange: function(selections) {
      this.selections = selections
      this.approvalList = []
      this.dispatchList = []
      this.canDeleteList = []
      this.selections.forEach(dev => {
        if (dev.Status === '已报修') {
          this.approvalList.push(dev)
          this.canDeleteList.push(dev)
        } else if (dev.Status === '已派工') {
          this.approvalList.push(dev)
        }
      })
    },
    visibleChange(isVisible) {
      const isEdge = window.navigator.userAgent.includes('Edge')
      if (isEdge && !isVisible) {
        document
          .querySelectorAll('body > .el-select-dropdown.el-popper')
          .forEach(it => it.remove())
      }
    },
    sizeChange: function(size) {
      this.pageSize = size
      this.getlist()
    },
    refreshPageRequest: function(pageNum) {
      this.currentPage = pageNum
      this.getlist()
    },
    dateFormat: function(row, column) {
      let time = dateFormat(row, column)
      return time
    }
  },
  components: {
    PictureList
  },
  mounted() {
    this.getlist()
    this.getRepairShop()
  }
}



// WEBPACK FOOTER //
// ./src/admin/Repair/RepairHome.vue